import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router';

interface AnalyticsProviderProps {
  children: React.ReactNode;
  trackingId: string;
}

// If no trackingId is provided, analytics will not be initialized
export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({ children, trackingId }) => {
  const location = useLocation();

  useEffect(() => {
    // Only initialize GA4 if enabled (in production/preview)
    if (trackingId) {
      ReactGA.initialize(trackingId);
    }
  }, [trackingId]);

  useEffect(() => {
    // Only track page views if analytics is enabled
    if (trackingId) {
      const currentPath = location.pathname + location.search;
      ReactGA.send({ hitType: 'pageview', page: currentPath });
    }
  }, [location, trackingId]);

  return <>{children}</>;
};
